<template>
  <div class="field col-12">
    <TituloComponent
      classTitulo="text-blue-800 text-xl font-bold mb-2"
      :titulo="titulo"
      :exiberLinha="false"
    />
    <Dropdown
      v-if="contarCaracteresOptions(options)"
      :options="options"
      optionLabel="descricao"
      v-model="value"
      placeholder="Selecione"
      @change="selecionar($event.value)"
    />
    <div class="grid m-0 p-selectbutton p-buttonset p-component" v-else role="group">
      <div
        v-for="item in options"
        :key="item.codigo"
        :tabindex="item.codigo"
        aria-label="Fund/Medio"
        role="radio"
        aria-checked="false"
        :class="{
          'p-button p-component pl-0 pr-0': true,
          'p-highlight': item.codigo === ativo,
        }"
        @click.prevent="selecionar(item)"
      >
        <span class="p-button-label">{{ item.descricao }}</span
        ><span class="p-ink" role="presentation"></span>
      </div>
    </div>
  </div>
</template>

<script>
import TituloComponent from "@/components/comuns/TituloComponent.vue";
import Dropdown from "primevue/dropdown";

export default {
  name: "SelectButton",

  emits: ["update:modelValue", "focus", "blur", "change"],

  props: {
    titulo: String,
    options: Array,
    ativo: Number,
    classDiv: {
      type: String,
      default: "col",
    },
  },

  data() {
    return {
      value: null,
    };
  },

  methods: {
    selecionar(item) {
      this.$emit('update:modelValue', item);
    },

    contarCaracteresOptions(values) {
      if (values.length == 0)
        return false

      if (values.length > 3)
        return true

      var qtdCaracteres = 0;
      values.forEach(function(value) {
        qtdCaracteres += value.descricao.length
      });

      if (qtdCaracteres > 30)
        return true

      return false
    }
  },

  components:{
    TituloComponent,
    Dropdown
  }
};
</script>

<style scoped>
  .p-button {
    overflow: initial;
    margin-bottom: 0.5rem !important;
  }
  
  .p-buttonset .p-button:not(:last-child) {
    border-right: 1px solid #d9d9d9 !important;
  }
</style>
